// Las miniaturas (`opt/`) de las celdas que SÍ son filas de `imagenes_generadas`, firmadas
// en lote — ADR-2026-09-17-la-barra-cuenta-lo-accionable.
//
// `urlDe` sólo sabía de las imágenes propias (las que nacen con `url`), así que los
// paneles del modo —el recuadro de PanelDeAccion, las partes de PanelMezclar— dibujaban
// un hueco en cuanto la celda era una generada. Acá salen esas urls, con el mismo camino
// que el resto de la app: `opt/` (800 px, el tamaño de grilla) y una sola vuelta de
// Storage por lote. Los videos se saltean: en este modo no hay, y su miniatura es el
// gemelo `.png`, que es otra historia.

import { useEffect, useState } from 'react';
import type { DatosCelda } from '../../components/useDatosDeCeldas';
import { firmarEnLote } from '../../../../utils/firmarEnLote';

const pathDeOpt = (companyId: string, fileName: string): string => `${companyId}/opt/${fileName}`;

const conArchivo = (datos: Map<string, DatosCelda>): DatosCelda[] =>
  [...datos.values()].filter((d) => !!d.fileName && d.tipo !== 'video');

export function useUrlsDeFilas(
  datosDeFilas: Map<string, DatosCelda>,
  companyId: string | null,
): Map<string, string> {
  const [urls, setUrls] = useState<Map<string, string>>(new Map());
  // La clave del efecto son los ids con archivo: el Map se rehace en cada vuelta de
  // `useDatosDeCeldas` aunque su contenido sea el mismo.
  const clave = conArchivo(datosDeFilas)
    .map((d) => d.id)
    .sort()
    .join('|');
  useEffect(() => {
    if (!companyId) return;
    const faltan = conArchivo(datosDeFilas).filter((d) => !urls.has(d.id));
    if (faltan.length === 0) return;
    let vivo = true;
    void firmarEnLote(faltan.map((d) => pathDeOpt(companyId, d.fileName as string)))
      .then((firmas) => {
        if (!vivo) return;
        setUrls((prev) => {
          const next = new Map(prev);
          for (const d of faltan) {
            const u = firmas.get(pathDeOpt(companyId, d.fileName as string));
            if (u) next.set(d.id, u);
          }
          return next;
        });
      })
      .catch((e) => {
        // Sin firma el panel se queda sin miniatura (el recuadro vacío que ya dibuja); no
        // hace falta un estado de error: el próximo cambio de filas reintenta.
        console.error('[useUrlsDeFilas] firmar', e);
      });
    return () => {
      vivo = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clave, companyId]);
  return urls;
}
